import { render, staticRenderFns } from "./IndividualList.vue?vue&type=template&id=fd23d730"
import script from "./IndividualList.vue?vue&type=script&lang=js"
export * from "./IndividualList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports